import React, { useState } from "react";
import Modal from "../../../../components/modals/Modal";
import { doc, updateDoc } from "firebase/firestore";
import {
  ref as ref_storage,
  getDownloadURL,
  uploadBytes,
  deleteObject,
} from "firebase/storage";
import { firestore, storage } from "../../../../firebase/config";
import { MdOutlineAddAPhoto } from "react-icons/md";
import { useTranslation } from "react-i18next";
import Loading from "../../../../components/loading/Loading";
import handleImageSelect from "../../../../functions/handleImageSelect";

const UpdatePhoto = ({ tournamentId, currentImageSrc }) => {
  const { t } = useTranslation();

  const [isModalOpen, setIsModalOpen] = useState(false);
  const [image, setImage] = useState({});
  const [isLoading, setIsLoading] = useState(false);

  const handleSetImage = (value) => {
    setImage(value);
  };

  const toggleModal = () => {
    setIsModalOpen(!isModalOpen);
  };

  const uploadImage = async () => {
    if (!image.name) {
      return null;
    }

    const imageName = Date.now().toString() + image.name;
    const newImageStorageRef = ref_storage(storage, `images/${imageName}`);

    const imageSnapshot = await uploadBytes(newImageStorageRef, image);

    const imageUrl = await getDownloadURL(imageSnapshot.ref);

    return imageUrl;
  };

  const getPathFromUrl = (url) => {
    const match = url.match(/\/o\/(.+?)\?/);

    if (match && match[1]) {
      return decodeURIComponent(match[1]); // returns 'images/example.jpg'
    }

    throw new Error("Invalid Firebase Storage URL");
  };

  const writeNewOrganizer = async () => {
    if (!image.name) {
      toggleModal();
      return;
    }

    setIsLoading(true);

    const button = document.getElementById("modal-confirm-button");
    button.disabled = true;

    try {
      const imageUrl = await uploadImage();

      const tournamentRef = doc(firestore, "tournaments", tournamentId);
      await updateDoc(tournamentRef, { imageSrc: imageUrl });

      if (currentImageSrc) {
        const imagePath = getPathFromUrl(currentImageSrc);
        const prevImageStorageRef = ref_storage(storage, imagePath);

        await deleteObject(prevImageStorageRef);
      }

      window.location.reload();
    } catch (error) {
      alert(error.message);
    }
  };

  return (
    <div className="w-full mb-2">
      <MdOutlineAddAPhoto
        className="h-8 w-8 text-stone-600 cursor-pointer"
        onClick={() => toggleModal()}
      />

      <Modal
        isOpen={isModalOpen}
        title="Update tournament photo"
        subtitle="This will replace the current photo if there is already one"
        onCancel={toggleModal}
        onConfirm={writeNewOrganizer}
      >
        <div className="w-full flex justify-start items-center my-4">
          {isLoading ? (
            <Loading />
          ) : (
            <>
              <label
                htmlFor="tournament-photo-upload"
                className="w-xl cursor-pointer bg-blue-50 text-blue-700 rounded-full text-md
                py-2 px-6 mr-5 font-medium"
              >
                {t("page.organize.newTournament.form.chooseImage")}
              </label>
              <input
                id="tournament-photo-upload"
                type="file"
                onChange={(event) => handleImageSelect(event, handleSetImage)}
                accept="image/png, image/jpeg, image/png"
                className="file:hidden"
              />
            </>
          )}
        </div>
      </Modal>
    </div>
  );
};

export default UpdatePhoto;
